import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { UsersSkillsInterface } from "../../interface/usersSkillsInterface";
import { ROLES } from "../../assets/data/roles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    color: theme.palette.text.primary,
}));
const StyledTableRow = styled(TableRow)(() => ({
    backgroundColor: "white",
}));

interface CellNamesParams {
    cellOne: string;
    cellTwo: string;
    cellTree: string;
    cellFour: string;
}

interface MyTableParams {
    data: UsersSkillsInterface[];
    cellNames: CellNamesParams;
    showRoleColumn?: boolean;
}
const MyTable = ({ data, cellNames, showRoleColumn }: MyTableParams) => {
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow
                        sx={{
                            backgroundColor: "#f9fafc",
                        }}
                    >
                        <StyledTableCell>{cellNames.cellOne}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellTwo}</StyledTableCell>
                        <StyledTableCell>{cellNames.cellTree}</StyledTableCell>
                        {showRoleColumn && (
                            <StyledTableCell>
                                {cellNames.cellFour}
                            </StyledTableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row: UsersSkillsInterface) => (
                        <StyledTableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                                {row.skills
                                    .map((skill) => skill.name)
                                    .join(", ")}
                            </TableCell>
                            <TableCell>{row.email}</TableCell>
                            {showRoleColumn && (
                                <TableCell>
                                    {ROLES[row.role_id]
                                        ? ROLES[row.role_id]
                                        : ""}
                                </TableCell>
                            )}
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MyTable;
